var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code",style:(_vm.divStyle)},[_c('img',{staticClass:"qr-img",style:(_vm.imgStyle),attrs:{"src":_vm.imgCodePath,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }